import { Component, h, Host, JSX, Event, EventEmitter, Prop } from '@stencil/core';
import { store } from '../../utils/store';
import { LocalesEnum } from '../../generated/operations';
import { MESSAGES, USER_SETTINGS } from '../constants';
import { UserSettings } from '../../types/UserSettings';

@Component({
  tag: 'app-locale-selector',
  shadow: false,
})
export class AppLocaleSelector {
  @Prop() full = true;
  @Event() belimoLocaleSelected!: EventEmitter<LocalesEnum>;

  public render(): JSX.Element {
    if (store.state.config === null) {
      return '';
    }
    const country = store.state.config.countries.find((item) => item.code === store.state.currentCountry);
    if (!country) {
      return '';
    }
    return (<Host>
      {this.full && <strong><belimo-i18n messageId={MESSAGES.SELECT_LOCALE}/>:  </strong>}
      <ul>
      {country.data.locales.map((localeData) => (
        <li class={{'selected': store.state.currentLocale === localeData.locale}}>
          <a href="#" onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.chooseLocale(localeData.locale);
          }}>
            {this.full ? localeData.name : localeData.locale.substring(0, 2)}
          </a>
        </li>
      ))}
      </ul>
      <slot name="close" />
    </Host>)
  }

  private async chooseLocale(locale: LocalesEnum): Promise<void> {
    if (store.state.currentLocale === locale) {
      this.belimoLocaleSelected.emit(locale);
      return;
    }
    store.state.isRegionDetected = false;
    store.state.oldState = {
      config: store.state.config,
      settings: {
        shoppingCenter: store.state.shoppingCenter,
        currentCountry: store.state.currentCountry,
        currentLocale: store.state.currentLocale,
        currentRegion: store.state.currentRegion,
      }
    }
    const userSettings: UserSettings = {
      currentLocale: locale,
      shoppingCenter: store.state.shoppingCenter,
      currentRegion: store.state.currentRegion,
      currentCountry: store.state.currentCountry,
    };
    const storage = store.state.offlineStorage;
    await storage.set(USER_SETTINGS, JSON.stringify(userSettings));
    store.state.currentLocale = locale;
    store.state.currentLocaleAndRegion = {
      locale,
      region: store.state.currentRegion,
    }
    this.belimoLocaleSelected.emit(locale);
  }
}
